import { getI18n as e } from "@editor/ui-utils";
//#endregion
//#region src/index.ts
var t = {
	messages: {
		en: {
			channelizerApi: {
				createAlreadyExists: "The channelizer cannot be created because another channelizer with this name already exists.",
				updateAlreadyExists: "The channelizer cannot be updated because another channelizer with this name already exists.",
				created: "Channelizer created",
				updated: "Channelizer updated",
				notFound: "Channelizer not found",
				requiredFields: "The channelizer cannot be saved because mandatory information is missing."
			},
			channelizerList: {
				newButton: "New channelizer",
				name: "Search by channelizer title",
				deleteChannelizer: "Delete",
				dpAny: "All",
				brand: "Brand",
				loading: "Loading channelizer",
				headerLabel: "Channelizer title (internal)",
				headerCreatedAt: "Creation date",
				headerChangedAt: "Last modified date",
				dpEdit: "Edit",
				dpView: "View",
				messageDeleted: "Message deleted",
				errorOnDeleting: "Error deleting",
				createChannelizer: "Create channelizer"
			},
			channelizer: {
				channelizerLabel: "Channelizer",
				newChannelizer: "New channelizer",
				messageDeleteChannelizer: "Delete channelizer",
				messageDeleteChannelizerTitle: "Are you sure you want to delete this channelizer?",
				deleteChannelizer: "Delete",
				messageDeleted: "Channelizer deleted",
				errorOnDeleting: "Error deleting the channelizer",
				errorFailedLoadedChannelizerWithId: "Error getting the channelizer"
			},
			channelizerEdit: {
				label: "Label",
				goToPage: "To page",
				editChannelizer: "Edit channelizer",
				messageSaved: "New channelizer saved",
				generalSettings: "General settings",
				title: "Channelizer title",
				seoTitle: "SEO headline",
				seoDescription: "SEO description",
				canonicalUrl: "URL of the subdomain",
				showCopyright: "Show copyright",
				partnerBannerSettings: "Partner banner settings",
				partnerOfferText: "Partner description text",
				partnerOfferTextTooltip: "If empty, no text will be displayed",
				partnerOfferImageUrl: "Partner logo URL",
				partnerOfferImageUrlTooltip: "This URL needs to be a valid image URL. If empty, no image will be displayed.",
				advancedSettings: "Advanced settings",
				contentPassEnabled: "Activate Contentpass",
				consentEnabled: "Activate consent",
				trackingEnabled: "Activate tracking",
				footerSettings: "Footer settings",
				imprintUrl: "Custom imprint URL",
				conditionsUrl: "Custom terms and conditions URL",
				contactUrl: "Custom contact URL",
				dataPrivacyUrl: "Custom data privacy URL",
				footerTooltip: "If empty, the default URL will be used"
			}
		},
		de: {
			channelizerApi: {
				createAlreadyExists: "Der Channelizer kann nicht erstellt werden, weil bereits ein anderer Channelizer mit diesem Namen existiert.",
				updateAlreadyExists: "Der Channelizer kann nicht aktualisiert werden, weil bereits ein anderer Channelizer mit diesem Namen existiert.",
				created: "Channelizer erstellt",
				updated: "Channelizer aktualisiert",
				notFound: "Channelizer nicht gefunden",
				requiredFields: "Der Channelizer kann nicht gespeichert werden, weil Pflichtinformationen fehlen."
			},
			channelizerList: {
				newButton: "Neuer Channelizer",
				name: "Nach Channelizer suchen",
				deleteChannelizer: "Löschen",
				dpAny: "Alle",
				brand: "Marke",
				loading: "Channelizer wird geladen",
				headerLabel: "Channelizer-Titel (intern)",
				headerCreatedAt: "Erstellungsdatum",
				headerChangedAt: "Änderungsdatum (Last modified)",
				dpEdit: "Bearbeiten",
				dpView: "Anzeigen",
				messageDeleted: "Nachricht gelöscht",
				errorOnDeleting: "Fehler beim Löschen",
				createChannelizer: "Channelizer erstellen"
			},
			channelizer: {
				channelizerLabel: "Channelizer",
				newChannelizer: "Neuer Channelizer",
				messageDeleteChannelizer: "Channelizer löschen",
				messageDeleteChannelizerTitle: "Willst du diesen Channelizer wirklich löschen?",
				deleteChannelizer: "Löschen",
				messageDeleted: "Channelizer gelöscht",
				errorOnDeleting: "Fehler beim Löschen des Channelizers",
				errorFailedLoadedChannelizerWithId: "Fehler beim Abrufen des Channelizers"
			},
			channelizerEdit: {
				label: "Label",
				goToPage: "Zur Seite",
				editChannelizer: "Channelizer bearbeiten",
				messageSaved: "Neuer Channelizer gespeichert",
				generalSettings: "Allgemeine Einstellungen",
				title: "Channelizer-Titel",
				seoTitle: "SEO Titel",
				seoDescription: "SEO-Beschreibung",
				canonicalUrl: "URL der Sub-Domain",
				showCopyright: "Copyright anzeigen",
				partnerBannerSettings: "Partner-Banner-Einstellungen",
				partnerOfferText: "Partner-Beschreibungstext",
				partnerOfferTextTooltip: "Wenn leer, wird kein Text angezeigt",
				partnerOfferImageUrl: "Partner-Logo-URL",
				partnerOfferImageUrlTooltip: "Diese URL muss eine gültige Bild-URL sein. Wenn leer, wird kein Bild angezeigt.",
				advancedSettings: "Erweiterte Einstellungen",
				contentPassEnabled: "Contentpass aktivieren",
				consentEnabled: "Consent aktiviert",
				trackingEnabled: "Tracking aktivieren",
				footerSettings: "Footer-Einstellungen",
				imprintUrl: "Eigene Impressums-URL",
				conditionsUrl: "Eigene AGB-URL",
				contactUrl: "Eigene Kontakt-URL",
				dataPrivacyUrl: "Eigene Datenschutz-URL",
				footerTooltip: "Wenn leer, wird die Standard-URL verwendet"
			}
		}
	},
	routes: [{
		path: "/channelizer",
		children: [
			{
				path: "",
				name: "channelizer_list",
				component: () => import("./channelizer-list.view-81D-WsUX.js"),
				meta: { requiredRight: "channelizers:navigate" }
			},
			{
				path: "new",
				name: "channelizer_new",
				component: () => import("./channelizer-edit.view-UBAO50ox.js"),
				props: () => ({ title: e().t("channelizer.newChannelizer") }),
				meta: { requiredRight: ["channelizers:navigate"] }
			},
			{
				path: ":id",
				name: "channelizer_detail",
				component: () => import("./channelizer-edit.view-UBAO50ox.js"),
				props: (t) => ({
					title: e().t("channelizerEdit.editChannelizer"),
					id: t.params.id,
					backRoute: "/channelizer"
				}),
				meta: { requiredRight: ["channelizers:navigate"] }
			}
		]
	}]
};
//#endregion
export { t as channelizerModule };

//# sourceMappingURL=index.es.js.map